import { StringUtil, Cookies } from '../../util/index'
import API from '../../api/index';


function GetRequest() {
    var url = location.search; //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            var str = strs[i].split("=");
            var key = str[0];
            var val = unescape(str[1]);
            if (key) {
                Cookies.set(key, val);
            }
            theRequest[key] = val;
        }
    }
    return theRequest;
}
var checkCarNum = function(array, index) {
    if (array && array.length >= index) {
        for (let i = 0; i < index; i++) {
            if (StringUtil.isEmpty(array[i])) {
                return false;
            }
        }
        return true;
    }
    return false;
}
var changeButtonStatus = function(carNum) {
    if (window.discount) {
        $('.xinnengyuan').hide();
        if (checkCarNum(carNum, 7)) {
            $('#submitBtn').attr('class', 'aaa');
            $('#submitBtn').removeAttr('disabled');
        } else {
            $('#submitBtn').addClass('disabled');
            $('#submitBtn').attr('disabled', 'true');
        }
    } else {
        $('.xinnengyuan').show();
        if (checkCarNum(carNum, 8)) {
            $('#submitBtn').attr('class', 'aaa');
            $('#submitBtn').removeAttr('disabled');
        } else {
            $('#submitBtn').addClass('disabled');
            $('#submitBtn').attr('disabled', 'true');
        }
    }
}
var Request = new Object();

var carNumOld = "";
var gatewayId = "";
var orderId = "";
var parkId = "";
var userId = "";
var userType = "";
var carNumStr = "";

function initData(req) {
    carNumOld = req['carNum'];
    gatewayId = req['gatewayId'];
    orderId = req['orderId'];
    parkId = req['parkId'];
    userId = req['userId'];
    // carNumStr = req['carNumStr'];
}

export const idx = {
    orderId,
    parkId,
    data() {
        return {
            "parkId": parkId,
            "carNumStr": carNumStr
        };
    },
    setCarNum(car) {
        if (car.carCategory) {
            $('.squaredThree.headLable').removeClass('headLable-check');
            switch (car.carCategory) {
                case '2':
                    $('.squaredThree.headLable.headLable-hp').click();
                    break;
                case '1':
                    $('.squaredThree.headLable.headLable-xny').click();
                    break;
                case '0':
                default:
                    $('.squaredThree.headLable.headLable-lp').click();
                    break;
            }
            carNumStr = car.carNo;

            var carNoAry = carNumStr.split('');
            $('.carLicenseMain ul li').each(function(index, element) {
                $(element).html(carNoAry[index]);
                if (index == 7 && car.carCategory != '1') {
                    $(element).html('');
                }
            });
            changeButtonStatus(carNoAry);
        }

    },
    init() {
        $('#textBox').hide();
        $('#provinceBox').hide();
        $('#carPlateBox').hide();
        Request = GetRequest();
        initData(Request);

        var locationUrl = "";
        if (/MicroMessenger/.test(window.navigator.userAgent)) {
            userType = 0;
            Cookies.set("userType", userType);
            locationUrl = API.auth_url + userType;
        } else if (/AlipayClient/.test(window.navigator.userAgent)) {
            userType = 1;
            Cookies.set("userType", userType);
            locationUrl = API.auth_url + userType;
        }


        if (userId) {
            Cookies.set('userId', userId);
        } else {
            if (!Cookies.get('userId')) {
                Cookies.set('retryAuth', Number(Cookies.get('retryAuth')) + Number(1));
                if (Cookies.get('retryAuth') < 3) {
                    if (locationUrl) {
                        window.location.href = locationUrl;
                        return;
                    }
                }
            }
        }

        var carNum = ['', '', '', '', '', '', '', '']; //车牌输入数组
        var num = 0; //需要输入的车牌数
        var numPlus = 0; //需要输入的车牌数
        $('#provinceBox').hide();
        // 车牌号输入点选
        $(".carLicenseMain ul li").on('click', function() {
            $('.carLicenseMain ul li').removeClass("active");
            $(this).addClass(" active");

            var index = getIndex();
            num = index;

            if (index == 0) {
                $('#textBox').hide();
                $('#provinceBox').show();
                $('#carPlateBox').show();
            } else if (index == 7) {
                $('#textBox').show();
                $('#provinceBox').hide();
                $('#carPlateBox').show();
                $('.carLicenseMain ul li').removeClass("active");
                $(this).addClass("active");
            } else {
                $('#textBox').show();
                $('#provinceBox').hide();
                $('#carPlateBox').show();
            }
        });

        // 选中值
        window.discount = 1;
        $(".squaredThree").each(function() {
            $(this).on('click', function() {
                window.discount = $(this).val();
                // console.log(carNum);
                $('.carNumType li').removeClass("headLable-check");
                $(this).addClass('headLable-check');

                changeButtonStatus(carNum);
            });
        });
        //关闭键盘
        $('.changeContentBtn').on('click', function() {
            $('#textBox').hide();
            $('#provinceBox').hide();
            $('#carPlateBox').hide();
        })

        //获取当前车牌数字索引
        var getIndex = function() {
            var index = 0;
            $('.carLicenseMain ul li').each(function() {
                var reg = new RegExp('active');
                if (reg.test($(this).attr('class'))) {
                    index = $(this).index();
                }
            })
            return index;
        }

        //输入车牌
        var keyboard = function(num, self) {
            var index = getIndex();
            num = index
            carNum.splice(index, 1, $(self).html().trim());
            carNumStr = carNum.join('');
            if (carNum[0] != "" && carNum[1] != "" && carNum[2] != "" && carNum[3] != "" && carNum[4] != "" && carNum[5] != "" && carNum[6] != "" && carNum[7] != "") {
                $('.carLicenseMain ul li.active').html($(self).html())
                $('.radios').attr('style', 'visibility:hidden')
                $('#submitBtn').attr('class', 'aaa')
                $('#submitBtn').removeAttr('disabled')
            }
            if (num < 7) {
                if (num == 6 && window.discount) {
                    $('.carLicenseMain ul li.active').html($(self).html()).removeClass('active').next().addClass('active')
                    $('#textBox').hide();
                    $('#provinceBox').hide();
                    $('#carPlateBox').hide();
                } else {
                    $('.carLicenseMain ul li.active').html($(self).html()).removeClass('active').next().addClass('active');
                    $('#textBox').show();
                    $('#provinceBox').hide();
                    $('#carPlateBox').show();
                    $('#submitBtn').addClass('disabled');
                    $('#submitBtn').attr('disabled', 'true');
                }
            } else if (num == 7) {
                $('.carLicenseMain ul li.active').html($(self).html()).removeClass('active').next().addClass('active')
                $('#textBox').hide();
                $('#provinceBox').hide();
                $('#carPlateBox').hide();
            }
            if (carNum[0] != "" && carNum[1] != "" && carNum[2] != "" && carNum[3] != "" && carNum[4] != "" && carNum[5] != "" && carNum[6] != "" && carNum[7] != "") {
                $('#submitBtn').attr('class', 'aaa')
                $('#submitBtn').removeAttr('disabled')
            }
            if (num == 6) {
                $('.carLicenseMain ul li.active').html();
            }
            if (carNum[0] != "" && carNum[1] != "" && carNum[2] != "" && carNum[3] != "" && carNum[4] != "" && carNum[5] != "" && carNum[6] != "") {
                if (window.discount) {
                    $('#submitBtn').attr('class', 'aaa');
                    $('#submitBtn').removeAttr('disabled');
                }
            }
            if ($('.carLicenseMain ul li:last-of-type').html() != "") {
                $('.radios').attr('style', 'visibility:hidden');
            }
        };
        //回退按钮点击事件
        $('.deleteBtn').on('click', function() {
            var index = getIndex();
            numPlus = index;
            if (index != 0) {
                if (numPlus < 7 || numPlus > 1) {
                    carNum.splice(index, 1, '');
                    $('.carLicenseMain ul li.active').html('');
                    $('.carLicenseMain ul li.active').removeClass('active').prev().addClass('active');
                }
                if (numPlus == 7) {
                    $('.carLicenseMain ul li:last-of-type').html('');
                    $('.radios').attr('style', 'visibility:visible');
                    carNum.splice(index, 1, '');
                }
                if (numPlus < 7) {
                    $('#submitBtn').addClass('disabled');
                    $('#submitBtn').attr('disabled', 'true');
                }
                changeButtonStatus(carNum);
                if (numPlus == 1) {
                    if (carNum[0] != "" || carNum[1] != "" || carNum[2] != "" || carNum[3] != "" || carNum[4] != "" || carNum[5] != "" || carNum[6] != "" || carNum[7] != "") {
                        // carNum = carNum;
                        console.log('carNum = carNum;')
                    } else {
                        carNum = ['', '', '', '', '', '', '', ''];
                    }
                    $('#textBox').hide();
                    $('#provinceBox').show();
                    $('#carPlateBox').show();
                }
                if (numPlus == 0) {
                    return false;
                } else {
                    index--;
                    numPlus--;
                    num--;
                }
            } else if (index == 0) {
                if (numPlus == 0) {
                    carNum.splice(index, 1, '');
                    $('#textBox').hide();
                    $('#provinceBox').show();
                    $('#carPlateBox').show();
                    $('.carLicenseMain ul li.active').html('');
                    $('#submitBtn').addClass('disabled');
                    $('#submitBtn').attr('disabled', 'true');
                }
            } else {
                return false;
            }
        });
        //省份键盘点击事件
        $('#provinceBox ul li:not(.other)').on('click', function() {
            var self = this;
            keyboard(num, self);
        });
        //文本键盘点击事件
        $('#textBox ul li:not(.other)').on('click', function() {
            var self = this;
            if (num == 8) {
                return false;
            } else {
                num++;
            }
            keyboard(num, self);
        })
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/index.js